import React from "react";
import {connect} from "react-redux";
import {closeModal} from "../../actions/modal";
import Video from "./modals/Video";
import Member from "./modals/Member";
import Search from "./modals/Search";
import Profile from "./modals/Profile";
import CTA from "./modals/CTA";
import api from "../../api";
import Close from "../../images/icons/close-white.svg";


class Modal extends React.Component {

    submit = data => {


        let formData = new FormData();
        formData.append('fields[formName]', data.formName);
        formData.append('fields[email]', data.email);
        formData.append('fields[number]', data.number);
        formData.append('fields[company]', data.company);
        formData.append('CRAFT_CSRF_TOKEN', this.props.CSRF);
        formData.append('action', 'guest-entries/save');
        formData.append('sectionId' , 12);
        api.forms.submitForm(formData).then((data) => this.props.closeModal()  );
    };
    close = data => {
        this.props.closeModal()
    };


    render() {
        const {modal, closeModal} = this.props;
        let className = `rob-modal__wrapper rob-modal__wrapper--${modal.activeClass}`;

        return (
          <div className={ modal.activeClass === false ? "rob-modal" : "rob-modal rob-modal--active"} >
              <div className={className}>
                  <div onClick={() => closeModal()} className="rob-modal__close hidden"><img src={Close} alt={"Close"} /></div>
                  <Video active={ modal.activeClass === 'video' ? "rob-modal__content rob-modal__content--video rob-modal__content--active" : "rob-modal__content "} videoId={modal.videoId}/>
                  <Member submit={this.submit} active={ modal.activeClass === 'member' ? "rob-modal__content rob-modal__content--member rob-modal__content--active" : "rob-modal__content "} />
                  <Search close={this.close} active={ modal.activeClass === 'search' ? "rob-modal__content rob-modal__content--search rob-modal__content--active" : "rob-modal__content "} />
                  <Profile active={ modal.activeClass === 'profile' ? "rob-modal__content rob-modal__content--profile rob-modal__content--active" : "rob-modal__content "}  {...modal}/>
                  <CTA active={ modal.activeClass === 'cta' ? "rob-modal__content rob-modal__content--cta rob-modal__content--active" : "rob-modal__content "}  {...modal}/>
              </div>
          </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        modal : state.modal,
        CSRF: state.csrf
    };
}

export default connect(mapStateToProps, {closeModal})(Modal);




// WEBPACK FOOTER //
// ./src/components/elements/Modal.js